/* Currency switcher */
document.addEventListener("DOMContentLoaded", function () {
  var currencySwitcher = document.getElementById('desktop-currency-switcher');

  if (currencySwitcher) {
    currencySwitcher.classList.remove('invisible');
  }
});